import { tenantsFeature, adapter } from './tenant.reducer';

// State-derived selectors (auto-generated by createFeature)
export const {
  selectAdminTenantsState,
  selectTotal: selectTenantTotal,   // server-side total (for paginator length)
  selectPage: selectTenantPage,
  selectLimit: selectTenantLimit,
  selectLoading: selectTenantsLoading,
  selectError: selectTenantsError,
} = tenantsFeature;

// Entity collection selectors
const entitySelectors = adapter.getSelectors(selectAdminTenantsState);
export const selectAllTenants = entitySelectors.selectAll;
export const selectTenantEntities = entitySelectors.selectEntities;
export const selectTenantIds = entitySelectors.selectIds;
export const selectTenantEntityCount = entitySelectors.selectTotal;
